<template>
  <div class="informationPage">
    <div class="forestTab">
      <p class="fgx"></p>
      <van-tabs v-model="activeName">
        <van-tab title="个人成效" name="userEffect" id="userEffect">
          <user-effect></user-effect>
        </van-tab>
        <van-tab title="个人考核" name="userAssess">
          <user-assess></user-assess>
        </van-tab>
        <van-tab title="组织成效" name="orgEffect">
          <org-effect></org-effect>
        </van-tab>
        <van-tab title="组织考核" name="orgAssess">
          <org-assess></org-assess>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
const refreshPage = () => import("@/components/common/refreshPage");
const userEffect = () => import("@/components/linLongModule/userEffectNew");
const userAssess = () => import("@/components/linLongModule/userAssessNew");
const orgEffect = () => import("@/components/linLongModule/orgEffect");
const orgAssess = () => import("@/components/linLongModule/orgAssessNew");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "information",
  data() {
    return {
      activeName: "userEffect", //默认选中第一项
      clientType: "", //手机类型
    };
  },
  mounted() {
    document.title = "林地信息";
    this.clientType = getDeviceType();
  },
  components: {
    userEffect,
    userAssess,
    orgEffect,
    orgAssess,
  },
};
</script>
<style lang="less">
.informationPage {
  width: 100%;
  height: 100%;
  .forestTab {
    > .fgx {
      width: 100%;
      height: 2px;
      background-color: #f6f6f6;
    }
    width: 100%;
    height: 100%;
    .van-tabs {
      height: 100%;
      overflow: hidden;
      .van-tabs__line {
        background-color: #4bc08a;
      }
      .van-tab--active {
        .van-tab__text {
          color: #4bc08a;
        }
      }
      .van-tabs__wrap {
        height: 45px;
      }
      .van-tabs__content {
        width: 100%;
        height: 93%;
        .van-tab__pane {
          width: 100%;
          height: 100%;
        }
        .orgAssess.van-tab__pane,
        .orgEffect.van-tab__pane {
          overflow-y: scroll;
        }
      }
    }
  }
}
</style>